module.exports = __webpack_public_path__ + "img/report-3.0e4d5fb0.jpg";